import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import img from "../../../images/asset.png"
import admin from "../../../images/admin.png"
import { useEffect } from 'react';
import { useState } from 'react';
import userRequest from "../../../utils/userRequest"
import { handleUserError } from '../../../utils/error';
import ImageConverter from '../../../utils/ImageConverter';
import ViewportMeta from '../../../utils/ViewportMeta';
import { useTranslation } from 'react-i18next';
import Sidebarfats from '../../../components/sidebar/Sidebarfats';
import imageLiveUrl from '../../../utils/urlConverter/imageLiveUrl';
const LocationDetails = () => {
  // get AssetData from location
  const { t, i18n } = useTranslation()
  const location = useLocation();
  const [imagesList, setImagesList] = useState([]); // [image1, image2, image3
  const [empName, setEmpName] = useState("");
  const [navigatePath, setNavigatePath] = useState("");
  // const { AssetData } = location.state;
  let AssetData = localStorage.getItem("AssetData");
  let navigation = localStorage.getItem("navigatePath");
  navigation = JSON.parse(navigation);
  // setNavigatePath(navigation);
  AssetData = JSON.parse(AssetData);
  console.log(AssetData);
  console.log(AssetData);
  const navigate = useNavigate();

  useEffect(() => {
    setNavigatePath(navigation);
    if (!AssetData) {
      navigate(navigation);
    }
    else {
      if (AssetData?.Images) {
        // let imagesliveUrls = imageLiveUrl(AssetData?.Images);
        // console.log(imagesliveUrls,'imagesliveUrls');
        
        // setImagesList(imagesliveUrls ?? []);
        let imagePaths = AssetData.Images.split(',')

// Convert each image path to a live URL
let imagesliveUrls = imagePaths.map(path => ImageConverter(path))

console.log(imagesliveUrls, 'imagesliveUrls')

setImagesList(imagesliveUrls ?? [])

      }

      userRequest.post("/getEmployeeListById", { "EmpID": AssetData?.EMPLOYEEID })
        .then(response => {
          setEmpName(response?.data?.recordset[0]?.EmpName ?? "")
        })
        .catch(error => {
          console.error(error);
          handleUserError(error)
        });
    }
  }, [])



  return (
    <>
      <div className={`p-0 h-full ${i18n.language === 'ar' ? 'sm:mr-72' : 'sm:ml-72'}`}>
     <ViewportMeta />
      <div className={`z-10 before:animate-pulse my-7 smm:my-10 before:bg-gradient-to-b before:from-gray-900 overflow-hidden before:via-[#00FF00] before:to-gray-900 ${i18n.language === 'ar' ? '2xl:ml-60 smm:mr-0' : '2xl:ml-60 smm:ml-0'}`}>
            <div className={`w-full h-auto px-3 sm:px-5 flex`}>
              <div
                className={`w-full sm:w-1/2 lg:w-[800px] px-6 bg-gray-500 bg-opacity-20 bg-clip-padding backdrop-filter backdrop-blur-sm text-white z-10 py-4  rounded-lg ${i18n.language === "ar" ? "direction-rtl" : "direction-ltr"
                  }`}
              >  <div className="w-full flex justify-center font-semibold p-6 shadow-xl text-black text-xl mb:2 md:mb-5">
              {t("Asset Location Employee Details")}
            </div>
            <form>
              <div className="mb-6">
                    <label htmlFor="locationtag" className="block mb-2 text-xs font-medium text-black">  {t("Location Tag")}</label>
                <input
                  placeholder={t("Location Tag")}
                  id="locationtag"
                  value={AssetData?.LocationTag}
                  readOnly
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
              </div>

              <div className="mb-6">
                <label htmlFor="tag" className="block mb-2 text-xs font-medium text-black">{t("TAG")}*</label>
                <input
                  id='tag'
                  placeholder={t("TAG")}
                  value={AssetData?.TagNumber}
                  readOnly
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
              </div>

              <div className="mb-6">
                <label htmlFor="assetlocationtag" className="block mb-2 text-xs font-medium text-black">{t("Asset Location Details")}*</label>
                <textarea
                  id="assetlocationtag"
                  readOnly
                  value={AssetData?.FullLocationDetails}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block h-28 w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder={t("Asset Location Details")}
                  required
                />
              </div >

              <div className="mb-6">
                <label htmlFor="department" className="block mb-2 text-xs font-medium text-black">{t("Serial No")}.</label>
                <input
                  id='department'
                  readOnly
                  value={AssetData?.sERIALnUMBER}
                  placeholder={t("Serial No")}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
              </div>

              <div className='flex justify-center items-center gap-2'>
                <div className='flex flex-col flex-wrap mb-6 w-[50%]'>
                  <label htmlFor="emp" className="block mb-2 text-xs font-medium text-black">{t("EMPLOAYEE ID")}*</label>
                  <input
                    id="emp"
                    readOnly
                    value={AssetData?.EMPLOYEEID}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("EMPLOAYEE ID")} />
                </div>

                <div className='flex flex-col flex-wrap mb-6 w-[50%]'>
                  <label htmlFor="phone" className="block mb-2 text-xs font-medium text-black">{t("Phone No")}.</label>
                  <input
                    id="phone"
                    readOnly
                    value={AssetData?.PhoneExtNo}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("Phone Number")} />
                </div>
              </div>

              <div className="mb-6">
                <label htmlFor="Business" className="block mb-2 text-xs font-medium text-black">{t("Name")}</label>
                <input
                  id="Business"
                  readOnly
                  value={empName}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("Business Name")} />
              </div>

              <div className="mb-6">
                <label htmlFor="other" className="block mb-2 text-xs font-medium text-black">{t("Other Tag")}</label>
                <input
                  id="other"
                  readOnly
                  value={AssetData?.ATMNumber}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
              </div>

              <div className="mb-6">
                <label htmlFor="notes" className="block mb-2 text-xs font-medium text-black">{t("Notes")}</label>
                <input
                  readOnly
                  value={AssetData?.DeliveryNoteNo}
                  id="notes"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
              </div>

              <div className='flex justify-center items-center gap-3 mb-6 w-full'>

                {imagesList?.length > 0 && (
                  imagesList.map((item, index) => (
                    <img 
                      src={item} className = 'h-20 w-full mt-5 cursor-pointer object-contain'
                      alt=''
                    />
                  ))
                )
                }
                 {/* <img 
                      src={imagesList}
                      className='h-20 w-full mt-5 cursor-pointer object-contain'
                      alt=''
                    /> */}
                <input
                  id='fileInput'
                  type='file'
                  style={{ display: 'none' }}
                  className='bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                  multiple
                />
              </div>

              <div className="mb-6">
                <label htmlFor="assetcondition" className="block mb-2 text-xs font-medium text-black">{t("Asset Condition")}</label>
                <input
                  readOnly
                  value={AssetData?.aSSETcONDITION}
                  id="assetcondition"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
              </div>

              <div className="mb-6">
                <label htmlFor="bought" className="block mb-2 text-xs font-medium text-black">{t("Bought")}</label>
                <input
                  id='bought'
                  readOnly
                  value={AssetData?.Bought}
                  placeholder='Bought'
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
              </div>

              <div className="mt-4 md:mt-10 flex justify-between w-full text-sm md:text-xl py-2 rounded-md">

                <button onClick={() => navigate('/member/cust')} type='submit' className="bg-[#00006B] text-white font-bold py-3 px-10 rounded-l">
                  {t("Back")}
                </button>

              </div>
            </form >
          </div >
        </div >
      </div >
      </div>
    </>
  )
}

export default LocationDetails